"use client";

import * as React from "react";
import * as RechartsPrimitive from "recharts";
import { Bot, ChartBar, MessageSquare, MonitorSmartphone } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartContainer } from "@/components/ui/chart";
const whatsappData = [{
  time: "08:00",
  msgs: 20
}, {
  time: "10:00",
  msgs: 55
}, {
  time: "12:00",
  msgs: 40
}, {
  time: "14:00",
  msgs: 95
}, {
  time: "16:00",
  msgs: 75
}, {
  time: "18:00",
  msgs: 125
}, {
  time: "20:00",
  msgs: 60
}];
const metricsData = [{
  day: "Seg",
  sales: 85
}, {
  day: "Ter",
  sales: 88
}, {
  day: "Qua",
  sales: 92
}, {
  day: "Qui",
  sales: 90
}, {
  day: "Sex",
  sales: 95
}, {
  day: "Sáb",
  sales: 98
}, {
  day: "Dom",
  sales: 94
}];
const whatsappChartConfig = {
  msgs: {
    label: "Telemetria",
    color: "var(--chart-1)"
  }
};
const metricsChartConfig = {
  sales: {
    label: "Precisão",
    color: "var(--chart-1)"
  }
};
const features = [{
  title: "Software Proprietário",
  description: "Inteligência artificial integrada para mapeamento 3D e detecção de anomalias estruturais em tempo real.",
  icon: MessageSquare,
  iconColor: "text-primary",
  glowClass: "group-hover:shadow-primary/20 group-hover:border-primary/50",
  chartType: "line"
}, {
  title: "Hardware Robusto",
  description: "Drones projetados com gaiolas de proteção de fibra de carbono para operar em espaços confinados extremos.",
  icon: Bot,
  iconColor: "text-primary",
  glowClass: "group-hover:shadow-primary/20 group-hover:border-primary/50",
  chartType: null
}, {
  title: "Treinamento de Pilotos",
  description: "Capacitação técnica de elite para operadores em cenários industriais críticos e ambientes sem GPS.",
  icon: ChartBar,
  iconColor: "text-primary",
  glowClass: "group-hover:shadow-primary/20 group-hover:border-primary/50",
  chartType: "bar"
}, {
  title: "Gestão de Ativos",
  description: "Painel completo de controle de frota e relatórios de inspeção automatizados para máxima produtividade.",
  icon: MonitorSmartphone,
  iconColor: "text-primary",
  glowClass: "group-hover:shadow-primary/20 group-hover:border-primary/50",
  chartType: null
}];
export default function TecnologiaQueTrabalhaPorVoce() {
  return <section data-section-id="166261" id="sobre" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-10">
        <div className="bg-primary/40 h-[600px] w-[600px] rounded-full blur-[140px]" />
      </div>

      <div className="container relative mx-auto px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-primary font-mono text-sm/6 font-semibold tracking-wider uppercase">
            Padrão Industrial
          </h2>
          <p className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">
            Excelência Operacional
          </p>
          <p className="text-muted-foreground mt-6 text-lg/8">
            Desenvolvemos tecnologia de ponta para inspeções em espaços confinados, 
            unindo hardware de alta resistência a softwares inteligentes para garantir 
            máxima segurança e precisão.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:mt-20 lg:max-w-none lg:grid-cols-4">
          {features.map((feature, i) => <div data-index={i} key={feature.title} className="flex">
              <Card className={`group relative flex w-full flex-col overflow-hidden border-border/40 bg-card/60 backdrop-blur-xl transition-all duration-500 hover:-translate-y-2 hover:rotate-1 hover:shadow-2xl ${feature.glowClass}`}>
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100 pointer-events-none" />

                <CardHeader className="relative z-10 pb-4">
                  <div className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-background/80 shadow-inner ring-1 ring-white/10 ${feature.iconColor}`}>
                    <feature.icon className="h-6 w-6 drop-shadow-[0_0_8px_rgba(88,179,59,0.5)]" />
                  </div>
                  <CardTitle className="text-xl font-bold tracking-tight">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent className="relative z-10 flex flex-1 flex-col">
                  <CardDescription className="text-muted-foreground text-base flex-1 leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}